import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, slate } from './glowUtil'
import { DOT_PREFIX } from './constant'

const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'

export default genComponentStyleHook(['Checkbox', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}-wrapper${DOT_PREFIX}`]: {
      [`${componentCls}-inner`]: {
        borderRadius: 1,
        borderColor: `${cyan[500]}30 !important`,
        background: `${slate[900]} !important`,
        transition,
      },

      [`&:hover ${componentCls}-inner`]: {
        borderColor: `${cyan[500]}60 !important`,
      },

      [`${componentCls}-checked`]: {
        [`${componentCls}-inner`]: {
          background: `${cyan[500]}25 !important`,
          borderColor: `${cyan[500]}80 !important`,
          boxShadow: `0 0 6px ${cyan[500]}25`,

          '&:after': {
            borderColor: `${cyan[500]} !important`,
          },
        },
      },
    },
  }
})
